var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Ai component
 */
export class BlocksIconAi extends BlocksElement {
    constructor() {
        super(...arguments);
        /**
         *
         * Append to the class name to pass classes (such as utility classes) into the internals
         */
        this.styleModifier = '';
    }
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span class="${componentClassName}" role="presentation">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <g clip-path="url(#clip0_21770_45)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.71565 1.89248C5.01141 0.518581 6.95809 0.508657 7.26601 1.88139L7.30068 2.03602C7.61301 3.42843 8.71333 4.48241 10.0781 4.72385C11.4982 4.97506 11.4982 7.02452 10.0781 7.27575C8.71333 7.51717 7.61301 8.57115 7.30068 9.96356L7.26601 10.1182C6.95809 11.4909 5.01141 11.481 4.71565 10.1071L4.68708 9.97441C4.38625 8.57696 3.28742 7.51534 1.92067 7.27356C0.503011 7.02276 0.502999 4.97683 1.92067 4.72603C3.28742 4.48424 4.38625 3.42262 4.68708 2.02519L4.71565 1.89248ZM16.5666 8.12983C16.184 6.42435 13.7705 6.43635 13.403 8.14366L13.3544 8.36923C12.7927 10.9784 10.738 12.9708 8.16947 13.4252C6.42007 13.7347 6.42007 16.2649 8.16947 16.5744C10.738 17.0288 12.7927 19.0212 13.3544 21.6303L13.403 21.8559C13.7705 23.5632 16.184 23.5752 16.5666 21.8698L16.6255 21.6068C17.2083 19.0085 19.2647 17.0315 21.8279 16.5781C23.5815 16.2679 23.5815 13.7317 21.8279 13.4215C19.2647 12.9681 17.2083 10.9911 16.6255 8.3927L16.5666 8.12983Z"
            />
          </g>
          <defs>
            <clipPath id="clip0_21770_45">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </span>
    `;
    }
}
__decorate([
    property()
], BlocksIconAi.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconAi.prototype, "iconTitle", void 0);
__decorate([
    property()
], BlocksIconAi.prototype, "size", void 0);
__decorate([
    property()
], BlocksIconAi.prototype, "styleModifier", void 0);
if (customElements.get('cat-icon-ai') === undefined) {
    customElements.define('cat-icon-ai', BlocksIconAi);
}
